const moment = require('moment-timezone');
import {
  DateFormats,
} from '../constants/DateFormats';

/**
 *
 * @param {*} inMs (default true)
 * @return {*} if inMS is True it will be in milliseconds, otherwise it is a moment object
 */
export function getCurrentDate(inMs = true) {
  const date = moment.utc();
  if (inMs) {
    return date.valueOf();
  }
  return date;
}

const tweleveHours = 12*60*60*1000;

/**
 *
 * @param {?} dateValue
 * @param {?} format
 * @return {?}
 */
export function formatDate(dateValue, format) {
  return moment.utc(dateValue).format(format);
}

/**
 * If a day is split in the middle it will go to the later day, the exception will be daylight savings time.
 * @param {*} utcTime
 * @param {*} timezone
 * @return {?} timestamp in utc
 */
export function roundDateToMidnight(utcTime, timezone) {
  const d = convertUTCDateInTimeZone(utcTime, timezone);
  const start = d.clone().startOf('day');
  const diff = moment.utc(d) - moment.utc(start);

  if (diff >= tweleveHours) {
    start.add(1, 'days');
  }
  return start.valueOf();
}

/**
 *
 * @param {?} period
 * @return {?}
 */
export function constructPeriodForDisplay(period) {
  let current = getCurrentDate(false);
  if (period) {
    current = period.periodStartdate;
  }
  return (
    'Period - ' +
    moment.utc(current).format(DateFormats.MONYYYY)
  );
}

/**
 * This function take time in UTC and return in company timezone and return moment object
 * @param {*} utctime
 * @param {*} timezone
 * @return {*}
 */
export function convertUTCDateInTimeZone(utctime, timezone) {
  const timeInUTC = moment.utc(utctime);
  if (timezone) {
    return timeInUTC.tz(timezone);
  }
  return timeInUTC;
}

/**
 *
 * @param {*} dateAsString
 * @param {*} format
 * @param {*} local
 * @param {*} timezone
 * @return {*}
 */
export function convertDate(
    dateAsString,
    format,
    local = false,
    timezone = null,
) {
  const date = convertUTCDateInTimeZone(dateAsString, timezone);
  if (local) {
    return date.local().format(format);
  }
  return date.format(format);
}
/**
 *
 * @param {*} datetime
 * @param {*} format
 * @param {*} timezone
 * @return {*}
 */
export function convertDateInTimeZoneToUTC(datetime, format = null, timezone = null) {
  if (format && timezone) {
    return moment.tz(datetime, format, timezone);
  }
  if (format && !timezone) {
    return moment.utc(datetime, format);
  }
  if (!format && timezone) {
    return moment.tz(datetime, timezone);
  }
  return moment.utc(datetime);
}

/**
 * Needs to be renamed or made into seperate function
 * @param {*} d
 * @param {*} inMs
 * @return {?}
 */
export function getValidDate(d, inMs = false) {
  const date = moment.utc(d);
  if (inMs) {
    return date.valueOf();
  }
  return date;
}

/**
 *
 * @param {*} date
 * @param {*} start
 * @param {*} end
 * @param {*} inclusive
 * @return {*}
 */
export function isDateBetweenStartAndEnd(date, start, end, inclusive = true) {
  if (inclusive) {
    return date >= start && date <= end;
  } else {
    return date > start && date < end;
  }
}

/**
 *
 * @param {*} start
 * @param {*} end
 * @return {*}
 */
export function inclusiveDayDiff(start, end) {
  if (start > end) {
    throw new Error(`inclusiveDayDiff called with invalid start and end dates, '+
    start must be before end [start=${start}] [end=${end}]`);
  }
  return end.diff(start, 'days') + 1;
}
